// removed by extract-text-webpack-plugin
module.exports = {"automation":"_13MFMs1fGr2hohnm8Hn1xw","automationForm":"_2kwZFTJRmQiz8IluE6lbB-","dataWrapper":"_2wjguCumYtBi__0NKVsZat","loader":"dlT7mK9LVLKvo2itTXs5A","red":"_1bu641xSvheOQAU1I9zr7e","green":"F4zNz8rPF0mgQcaFGDku2","black":"_2ro420jhsg722Zg1tQVgPs","whiteSpace":"_2s1aejNYIQk0rDPluSqukM","selectWrapper":"XrVKQQ2PJzX6MGuzoxkPE","listWrapper":"_35CT1ET1YbydZMtHIwgNCP","arrowIcon":"_1N2hovWN7DbK1Q0FhJYxIv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Automation/Automation.scss
// module id = 661
// module chunks = 0